import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AntiMoneyLaundering, AntiMoneyLaunderingJson } from '@common/models/anti-money-laundering';
import { COMPANY_API_ROUTE_BASE } from '@constants/api-routes.constant';
import { ApiAlertError } from '@decorators/api-alert-error';
import { HttpHelper } from '@helpers/http.helper';

@Injectable({
  providedIn: 'root'
})
export class AntiMoneyLaunderingApiService {
  constructor(private readonly http: HttpClient) {}

  @ApiAlertError()
  getAntiMoneyLaunderingConclusions(
    antiMoneyLaundering: AntiMoneyLaundering,
    companyId?: number
  ): Observable<AntiMoneyLaundering> {
    let url = `${COMPANY_API_ROUTE_BASE}/anti_money_launderings/conclusions_preview`;

    if (companyId) {
      url = HttpHelper.replaceCompanyUrl(url, companyId);
    }

    const body: AntiMoneyLaunderingJson = AntiMoneyLaundering.toJson(antiMoneyLaundering);

    return this.http
      .post<AntiMoneyLaunderingJson>(url, body)
      .pipe(
        map((antiMoneyLaunderingJson: AntiMoneyLaunderingJson) => AntiMoneyLaundering.fromJson(antiMoneyLaunderingJson))
      );
  }
}
